import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as apiCompany from "../../../../api/apiCompany"
import { Pagination } from '../../Res/Pagination';
import { ContentBox } from '../../Content/ContentBox';
import { EditButton, ListButton } from '../../Res/BaseButton';
import { AdminDepartmentEdit } from './AdminDepartmentEdit';
import { AdminDepartmentAdd } from './AdminDepartmentAdd';

export function AdminDepartmentList ({id}) {
  const [disableCount, setDisableCount] = useState(0)
  const [enableCount, setEnableCount] = useState(0)
  const [isEdit, setisEdit] = useState(false)
  const [department, setDepartment] = useState()
  const [change, setChange] = useState(false)
  const [departmentList, setDepartmentList] = useState()
  const [company, setCompany] = useState()

  var title = '部門列表'
  var title_tools = ''
  var content = 
  <ListBox id={id} setDisableCount={setDisableCount} setEnableCount={setEnableCount} toEdit={toEdit} ch={change} setList={setDepartmentList} setCompany={setCompany} />  

  function toEdit(status, c){
    console.log("toEdit")
    setisEdit(status)
    setDepartment(c)
    if(!status){
      setChange(!change)
    }
  }

  function cancel(){
    setChange(!change)
  }

  return (    
    <>
    <ContentBox title={title} enableCount={enableCount} disableCount={disableCount} disableText={"停權"} title_tools={title_tools} content={content}  hasDrawer={true} />
    {
        departmentList === undefined?<></>:
        isEdit?<AdminDepartmentEdit cancel={toEdit} department={department} list={departmentList} /> :
          <AdminDepartmentAdd id={id} list={departmentList} cancel={cancel}  />
    }
    </>
  )
}


function ListBox({id, setDisableCount, setEnableCount, toEdit, ch, setList, setCompany}){
  const [departmentList, setDepartmentList] = useState()
  const [page, setPage] = useState(1)
  const [count, setCount] = useState(0)
  const [limit] = useState(10)
  const [change, setChange] = useState(ch)
  //const [count, setCount] = useState(0)

  function getDepartmentList(){
    apiCompany.api_getDepartmentList({
      companyId: id, 
      success: (obj)=>{
        setCompany(obj.company)
        setDepartmentList(obj.list)
        setCount(obj.count)
        setDisableCount(obj.disableCount)
        setEnableCount(obj.enableCount)
        setList(obj.list)
        console.log(obj)
      },
      failure:(err)=>{
      }
    })
  }

  function sPage(p){
    if(p !== page){
      getDepartmentList()
      setPage(p)
    }
  }


  useEffect(()=>{
    if(departmentList === undefined){
      getDepartmentList()
    }
  },[])

  useEffect(()=>{
    if(change !== ch){
      setChange(ch)
      getDepartmentList()
    }
  })


  if(departmentList === undefined){
    return (<></>)
  }else{
    //console.log(managerList)
    return(
    <>
    <div className="box-body table-responsive no-padding">
    <table className="table no-margin">
      <tbody><tr>
        <th width="30%">部門名稱</th>
        <th width="30%">主管部門</th>
        <th width="10%">員工人數</th>
        <th width="10%">狀態</th>
        <th width="20%"></th>
      </tr>
      {
        departmentList.map((department)=>(
          <Box key={department.departmentId} item={department} toEdit={toEdit} />
        ))
        }
      
      </tbody>
    </table>
    </div>
    {
      count === 0? <></> : <Pagination p={page} l={limit} c={count} sp={sPage} />
    }
    </>
  )
  }
  
}

function Box({item, toEdit}){
  const [department, setDepartment] = useState(item)
  if(department !== item){
    setDepartment(item)
  }

  function toRole(){
    toEdit(false);
    window.location.assign("/AdminRoleList/"+department.departmentId);
  }

  var status ="<></>";
  if(department.isDisable === 1){
    status = <span className="label label-danger">停用</span>
  }else{
    status = <span className="label label-success">啟用</span>
  }

  function edit(){
    toEdit(true, department)
  }

  return(
    <tr>
      <td style={{verticalAlign:"middle"}}><div>{department.departmentName}</div></td>
      <td style={{verticalAlign:"middle"}}>{department.managerDepartmentName}</td>
      <td style={{verticalAlign:"middle"}}></td>
      <td style={{verticalAlign:"middle"}}>{status}</td>
      <td style={{verticalAlign:"middle"}}>
        <div className="btn-group">
          <EditButton action={edit} />
          <ListButton name={"角色"} action={toRole} />
        </div>
      </td>
    </tr>
  )
}